/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Full_Name_PlaceholderInputs */

const en_auth_full_name_placeholder = /** @type {(inputs: Auth_Full_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jane Doe`)
};

const de_auth_full_name_placeholder = /** @type {(inputs: Auth_Full_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Mustermann`)
};

const fr_auth_full_name_placeholder = /** @type {(inputs: Auth_Full_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jean Dupont`)
};

const es_auth_full_name_placeholder = /** @type {(inputs: Auth_Full_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juan Pérez`)
};

const it_auth_full_name_placeholder = /** @type {(inputs: Auth_Full_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mario Rossi`)
};

const nl_auth_full_name_placeholder = /** @type {(inputs: Auth_Full_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jan Jansen`)
};

const pl_auth_full_name_placeholder = /** @type {(inputs: Auth_Full_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jan Kowalski`)
};

const fi_auth_full_name_placeholder = /** @type {(inputs: Auth_Full_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maija Meikäläinen`)
};

const da_auth_full_name_placeholder = /** @type {(inputs: Auth_Full_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karen Jensen`)
};

const sv_auth_full_name_placeholder = /** @type {(inputs: Auth_Full_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anna Andersson`)
};

/**
* | output |
* | --- |
* | "Jane Doe" |
*
* @param {Auth_Full_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_full_name_placeholder = /** @type {((inputs?: Auth_Full_Name_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Full_Name_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_full_name_placeholder(inputs)
	if (locale === "fr") return fr_auth_full_name_placeholder(inputs)
	if (locale === "es") return es_auth_full_name_placeholder(inputs)
	if (locale === "it") return it_auth_full_name_placeholder(inputs)
	if (locale === "nl") return nl_auth_full_name_placeholder(inputs)
	if (locale === "pl") return pl_auth_full_name_placeholder(inputs)
	if (locale === "fi") return fi_auth_full_name_placeholder(inputs)
	if (locale === "da") return da_auth_full_name_placeholder(inputs)
	if (locale === "sv") return sv_auth_full_name_placeholder(inputs)
	return en_auth_full_name_placeholder(inputs)
});